import * as React from 'react';
import { DataList } from 'components/select-advanced';
import { Input } from 'components/input/IndexAdvanced';
import { formatValueIfNullOrUndefined } from 'utilities/util';

interface IParams {
    id:string;
    value:any;
    dropdownValue:any;
    className?: string;
    onChange: (e:any) => void;
    hasError:boolean;
    data:any[];
    isEditable: boolean
}
export const ICBComponent = (props:IParams) => {
        if(props.isEditable){
        return(
            <DataList 
                id={props.id}
                className={props.className}
                label={'ICB indicator'}
                value={props.dropdownValue}
                onChange={(e:any) =>{ props.onChange(e)}}
                hasError={props.hasError}
                error="Field is required"
                data={props.data} />
        )}else{
            return(<Input 
                label={'ICB indicator'}
                className={props.className}
                id={props.id}
                value={formatValueIfNullOrUndefined(props.value)}
                type="text" readonly={true} />)
        }
}